import { render, staticRenderFns } from "./PlanRead2.vue?vue&type=template&id=18538d15&scoped=true"
import script from "./PlanRead2.vue?vue&type=script&lang=js"
export * from "./PlanRead2.vue?vue&type=script&lang=js"
import style0 from "./PlanRead2.vue?vue&type=style&index=0&id=18538d15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18538d15",
  null
  
)

export default component.exports